import { render, staticRenderFns } from "./ClientBehaviour.vue?vue&type=template&id=3268a6d3&scoped=true&"
import script from "./ClientBehaviour.vue?vue&type=script&lang=js&"
export * from "./ClientBehaviour.vue?vue&type=script&lang=js&"
import style0 from "./ClientBehaviour.vue?vue&type=style&index=0&id=3268a6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3268a6d3",
  null
  
)

export default component.exports